/**
 * League Popup — mandatory league selector
 * Saves selection to localStorage and writes a cart attribute on every page load.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'lgpop_league_v2';

  // ── Persistence ──────────────────────────────────────────────────────────────

  function getSavedLeague() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  }

  function saveLeague(id, name) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ id: id, name: name }));
    } catch (_) {}
  }

  // ── Cart attribute ────────────────────────────────────────────────────────────

  function writeCartAttribute(leagueId, leagueName) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'League': leagueName,
          'League ID': leagueId
        }
      })
    }).catch(function () {});
  }

  // ── DOM helpers ───────────────────────────────────────────────────────────────

  function el(id) { return document.getElementById(id); }

  function showEl(element) {
    if (!element) return;
    element.hidden = false;
    element.style.display = '';
  }

  function hideEl(element) {
    if (!element) return;
    element.hidden = true;
  }

  function showError(message) {
    var errorEl = el('league-popup-error');
    if (!errorEl) return;
    errorEl.textContent = message;
    showEl(errorEl);
  }

  function hideError() {
    hideEl(el('league-popup-error'));
  }

  // ── Popup state ───────────────────────────────────────────────────────────────

  function openPopup() {
    var overlay = el('league-popup-overlay');
    if (!overlay) return;
    overlay.style.display = 'flex';
    document.body.classList.add('league-popup--open');
    setTimeout(function () {
      var select = el('league-popup-select');
      if (select) select.focus();
    }, 50);
  }

  function closePopup(leagueId, leagueName) {
    var overlay = el('league-popup-overlay');
    if (!overlay) return;
    overlay.style.display = 'none';
    document.body.classList.remove('league-popup--open');

    // Show floating badge with league name
    var triggerLabel = el('league-popup-trigger-label');
    if (triggerLabel) triggerLabel.textContent = leagueName;
    showEl(el('league-popup-trigger'));
  }

  // ── Confirm selection ─────────────────────────────────────────────────────────

  function confirmSelection() {
    var select = el('league-popup-select');
    if (!select || !select.value) {
      showError('Please select your league to continue.');
      if (select) select.focus();
      return;
    }

    hideError();

    var leagueId = select.value;
    var leagueName = select.options[select.selectedIndex].text;

    saveLeague(leagueId, leagueName);
    writeCartAttribute(leagueId, leagueName);
    closePopup(leagueId, leagueName);
  }

  // ── Event wiring ─────────────────────────────────────────────────────────────

  function wireEvents() {
    // Confirm button
    var confirmBtn = el('league-popup-confirm');
    if (confirmBtn) confirmBtn.addEventListener('click', confirmSelection);

    // Allow Enter key on the select to confirm
    var select = el('league-popup-select');
    if (select) {
      select.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') confirmSelection();
      });
    }

    // Floating badge — reopens popup to let user change their league
    var triggerBtn = el('league-popup-trigger');
    if (triggerBtn) {
      triggerBtn.addEventListener('click', function () {
        var saved = getSavedLeague();
        var selectEl = el('league-popup-select');
        if (saved && selectEl) selectEl.value = saved.id;
        hideEl(triggerBtn);
        openPopup();
      });
    }
  }

  // ── Init ──────────────────────────────────────────────────────────────────────

  function init() {
    if (!el('league-popup-overlay')) return;

    wireEvents();

    var saved = getSavedLeague();

    if (saved) {
      // Already selected — sync cart attribute and show badge
      writeCartAttribute(saved.id, saved.name);
      var triggerLabel = el('league-popup-trigger-label');
      if (triggerLabel) triggerLabel.textContent = saved.name;
      showEl(el('league-popup-trigger'));
    } else {
      // No selection yet — show mandatory popup
      openPopup();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
